import React, {FC} from 'react'

type Props = {
  message: any
}

const GiftMessage: FC<Props> = ({message}) => {
  if (!message) {
    return null
  }
  return (
    <>
      <div className='fs-5 fw-bolder pb-2'>Gift</div>
      <div className='text-gray-600'>
        <span className='text-gray-600'>
          {message.from && (
            <div>
              <span className='fw-bolder mt-5'>From : </span>
              {message.from}
            </div>
          )}
          {message.to && (
            <div>
              <span className='fw-bolder mt-5'>To : </span>
              {message.to}
            </div>
          )}
          {message.message && (
            <div>
              <span className='fw-bolder mt-5'>Message : </span>
              {message.message}
            </div>
          )}
        </span>
      </div>
    </>
  )
}

export default GiftMessage
